module.exports = __webpack_public_path__ + "img/fridgeicon.9aa56868.png";